import { VideoLayout2Theme } from '@components/video/components/video-layout-2/enum';
import { VideoLayout2Style } from '@components/video/components/video-layout-2/model';

export const videoLayout2Style: { [key: string]: VideoLayout2Style } = {
  [VideoLayout2Theme.BLUE]: {
    backgroundColor: 'BLUE',
    textColor: 'WHITE',
    labelColor: 'GREY_ALPHA',
  },
  [VideoLayout2Theme.RED]: {
    backgroundColor: 'RED',
    textColor: 'WHITE',
    labelColor: 'GREY_ALPHA',
  },
  [VideoLayout2Theme.OPAL]: {
    backgroundColor: 'OPAL',
    textColor: 'BLACK',
    labelColor: 'GREY_LIGHT',
  },
};
